<template lang="html">
    <form @submit.prevent="submit()" class="form">
        <div class="form__items">
            <template  v-if="personalCars.length" >
                <div class="form-item">
                    <div class="form-item__text">
                        Выберите ваш автомобиль для экономии времени заполнения заявки. При выборе автомобиля все параметры подставятся автоматически
                    </div>
                </div>
                <div class="form-item">
                    <label class="form-item__label">Ваш автомобиль</label>
                    <div class="default-select">
                        <roscar-select>
                            <select v-model="selectedPersonalCarId" class="default-select__select" data-placeholder="Выберите автомобиль" data-no-deselect="true">
                                <option data-placeholder="true"></option>
                                <option v-for="item in personalCars" :key="item.ID" :value="item.ID" >{{ item.UF_BRAND }} {{ item.UF_MODEL }} {{ item.UF_SHELL }}, {{ item.UF_YEAR }}</option>
                            </select>
                        </roscar-select>
                    </div>
                </div>
            </template>

            <car-selector v-slot="carSelectorSlotProps"
            v-model:brand="car.brand"
            v-model:model="car.model"
            v-model:year="car.year"
            v-model:modification="car.modification"
            @update:shell="car.shell = $event"
            @update:yearStart="car.yearStart = $event"
            @update:yearEnd="car.yearEnd = $event"
            >

                <div class="form-item required">
                    <label class="form-item__label">Марка</label>
                    <div :key="`car-year-${carSelectorSlotProps.params.brand}`" class="default-select">
                        <roscar-select >
                            <select v-model="carSelectorSlotProps.params.brand" v-keyboard.left data-search class="default-select__select" data-placeholder="Выберите марку авто" data-no-deselect="true">
                                <option data-placeholder="true"></option>
                                <option v-for="val in carSelectorSlotProps.brands" :key="val" :value="val" v-html="val" ></option>
                            </select>
                        </roscar-select>
                    </div>
                </div>
                <div v-if="carSelectorSlotProps.models.length" class="form-item required">
                    <label class="form-item__label">Модель</label>
                    <div :key="`car-year-${carSelectorSlotProps.params.model}`" class="default-select">
                        <roscar-select >
                            <select v-model="carSelectorSlotProps.params.model" v-keyboard.left data-search class="default-select__select" data-placeholder="Выберите марку авто" data-no-deselect="true">
                                <option data-placeholder="true"></option>
                                <option v-for="val in carSelectorSlotProps.models" :key="val" :value="val" v-html="val" ></option>
                            </select>
                        </roscar-select>
                    </div>
                </div>
                <div v-if="carSelectorSlotProps.years.length" class="form-item required">
                    <label class="form-item__label" for="new-auto-year">Кузов и год выпуска</label>
                    <div :key="`car-year-${carSelectorSlotProps.params.year}`" class="default-select">
                        <roscar-select>
                            <select v-model="carSelectorSlotProps.params.year" required="" class="default-select__select" data-placeholder="Выберите кузов и год выпуска" data-no-deselect="true">
                                <option data-placeholder="true"></option>
                                <option v-for="val in carSelectorSlotProps.years" :key="val" :value="val" v-html="val" ></option>
                            </select>
                        </roscar-select>
                    </div>
                </div>
                <div v-if="carSelectorSlotProps.modifications.length" class="form-item required">
                    <label class="form-item__label" for="new-auto-modification">Модицификация</label>
                    <div :key="`car-modification-${carSelectorSlotProps.params.modification}`" class="default-select">
                        <roscar-select>
                            <select class="default-select__select" required="" name="fields[modification]" data-placeholder="Выберите модификацию" v-model="carSelectorSlotProps.params.modification" >
                                <option data-placeholder="true"></option>
                                <option v-for="val in carSelectorSlotProps.modifications" :key="val" :value="val" v-html="val" ></option>
                            </select>
                        </roscar-select>
                    </div>
                </div>
            </car-selector>
            <div class="form-item">
                <label class="default-checkbox">
                    <input type="checkbox" v-model="car.runFlat" >
                    <span class="default-checkbox__point"></span>
                    <span class="default-checkbox__label">Run Flat</span>
                </label>
            </div>
        </div>
        <div v-if="car.modification" class="form__bottom">
            <button type="submit" class="btn">Рассчитать</button>
        </div>
        <div v-if="options.length" class="form__tabs">
            <p class="form__tabs-title">Выберите ваш типоразмер:</p>
            <ul class="form__tabs-list">
                <li v-for="item in options" :key="item.ID" @click.prevent="selectOption(item)" class="form__tabs-item" :class="{ active : selectedOption.ID == item.ID }" >
                    <p class="form__tabs-name">{{ item.UF_FRONT_WIDTH }}/{{ item.UF_FRONT_PROFILE }} R{{ item.UF_FRONT_DIAMETER }}</p>
                    <span v-if="item.servicePrice" class="form__tabs-value">{{ item.servicePrice }} ₽</span>
                </li>
            </ul>
        </div>
        <div v-if="selectedOption.ID" class="form__bottom">
            <button @click.prevent="$emit('continue')" class="btn">Продолжить</button>
        </div>
    </form>
</template>

<script>
import { ref, watch } from 'vue';
import { loadCarData } from '../../api';
import usePersonalCars from '../../composables/usePersonalCars';
export default {
    name : 'TireFittingPrice',
    emits : [ 'service-code:selected' ],
    setup (props, { emit }) {
        const car = ref({
            brand : '',
            model : '',
            year : '',
            modification : '',
            shell : '',
            yearStart : '',
            yearEnd : '',
            runFlat : false,
        });
        const selectedPersonalCarId = ref('');
        const personalCars = usePersonalCars().cars;
        if (!personalCars.length) {
            usePersonalCars().load();
        }
        watch(selectedPersonalCarId, () => {
            let personalCar = personalCars.value.find(c => c.ID == selectedPersonalCarId.value);
            if (personalCar) {
                car.value.brand = personalCar.UF_BRAND;
                car.value.model = personalCar.UF_MODEL;
                car.value.year = [
                        personalCar.UF_SHELL,
                        [
                            personalCar.UF_YEAR,
                            personalCar.UF_YEAR_END,
                        ].filter(v=>v).join(' - ')
                    ].filter(v=>v).join();
                car.value.modification = personalCar.UF_MODIFICATION;
            }
        });
        watch(() => car.value.modification, () => {
            options.value = [];
        });
        const selectedOption = ref({});
        const options = ref([]);
        watch(options, () => {
            let option = options.value.find(o => o.ID == selectedOption.value.ID);
            if (!option || option.servicePrice != selectedOption.value.servicePrice) {
                selectedOption.value = {};
            }
        });
        const selectOption = option => {
            selectedOption.value = option;
        }
        watch(selectedOption, () => {
            emit('service-code:selected', selectedOption.value.serviceCode);
        });
        const submit = () => {
            loadCarData({
                type : 'tires',
                brandName : car.value.brand,
                modelName : car.value.model,
                yearStart : car.value.yearStart,
                modification : car.value.modification,
                shell : car.value.shell,
                usePrice : 1,
                runflat : +car.value.runFlat,
            }).then(res => {
                if (res.data.options) {
                    let _options = {};
                    for (var i = 0; i < res.data.options.length; i++) {
                        let item = res.data.options[i];
                        let key = item.UF_FRONT_WIDTH +'-'+ item.UF_FRONT_PROFILE +'-'+ item.UF_FRONT_DIAMETER;
                        _options[ key ] = item;
                    }
                    options.value = Object.values(_options);
                }
            });
        }
        return {
            car,
            options,
            submit,
            selectOption,
            selectedOption,
            selectedPersonalCarId,
            personalCars,
        }
    }
}
</script>
